/*  It's information for dynamsoft barcode library */

/* eslint-disable no-underscore-dangle */
import { BarcodeReader } from 'dynamsoft-javascript-barcode'

BarcodeReader._bNeverShowDialog = true
BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxMzQxOTI4LVRYbFhaV0pRY205cVgyUmljZyIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTM0MTkyOCIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOjMwMzMwNDk2OX0='
BarcodeReader.engineResourcePath = '/dynamsoft-javascript-barcode/'
